<ng-template #nguidCellTempl let-row="row" let-value="value">
	<div class="nguid-cell" title="{{value}}">
		<i class="glyphicons glyphicons-fingerprint-scan"></i>
	</div>
</ng-template>
<ng-template #globalIdCellTempl let-row="row" let-value="value">
	<div title="{{value}}">
		<i class="glyphicons glyphicons-fingerprint-scan"></i>
	</div>
</ng-template>
<ng-template #qaErrorLevelCellTempl let-row="row" let-column="column" let-value="value">
	<div *ngIf="row[qaErrorLevelColName]==='CRITICAL'" title="Critical">
		<div></div> 
	</div>
	<div *ngIf="row[qaErrorLevelColName]==='WARNING'" title="Warning">
		<div ></div>
	</div>
</ng-template>